import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

import {
  sendMessage,
  addListener,
  removeListener,
} from "../services/websocketManager";

import { LottieAnimation } from "../lottie/LottieAnimation.js";
import WinLossDrawChart from "./charts/WinLossDrawChart.js";
import GameTypeChart from "./charts/GameTypeChart.js";
import GameTimeTypeChart from "./charts/GameTimeTypeChart.js";
import CombinedResultChart from "./charts/CombinedResultChart";
import UserTypeChart from "./charts/UserTypeChart";
import GamesPerDayChart from "./charts/GamesPerDayChart";
import GameResultByOpponentTypeChart from "./charts/GameResultByOpponentTypeChart";
import { GENERAL } from "../general/General";
import { useTranslation } from "react-i18next";

const ChartsPage = ({ updateBackground }) => {
  const { t } = useTranslation();
  const [gameInfos, setGameInfos] = useState([]);
  const [loading, setLoading] = useState(true);
  const isMobile = window.innerWidth <= 600;
  const getToday = () => new Date().toISOString().split("T")[0];
  const [fromDate, setFromDate] = useState("2025-01-01");
  const [toDate, setToDate] = useState(getToday());

  useEffect(() => {
    updateBackground({ image: GENERAL.BACKGROUND });

    const handleWebSocketEvent = (event) => {
      if (
        event.type === "message" &&
        event.message.messageType === "game_info_data"
      ) {
        setGameInfos(event.message.gameInfoList || []);
        setLoading(false);
      }
    };

    addListener(handleWebSocketEvent);
    requestForGameInfos("2025-01-01", getToday());

    return () => {
      removeListener(handleWebSocketEvent);
    };
  }, [updateBackground]);

  function requestForGameInfos(fromDate, toDate) {
    const message = {
      messageType: "get_game_info_data",
      ...(fromDate && { fromDate }),
      ...(toDate && { toDate }),
    };
    sendMessage(message);
  }

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <LottieAnimation
          path="https://res.cloudinary.com/dnlgtek2a/raw/upload/v1743418492/Lottie/search.json"
          width={isMobile ? "250px" : "400px"}
          height={isMobile ? "250px" : "400px"}
          autoplay
          loop
        />
      </Box>
    );
  }

  return (
    <div
      style={{
        padding: isMobile ? "16px" : "44px",
        //minHeight: "90vh",
        //height: "auto", // Add this
        //overflowY: "auto",
        //maxHeight: "none", // Ensure no max-height constraint
      //overflowY: "scroll", // Force scroll instead of auto
        //boxSizing: "border-box",
        //border: "2px solid blue", // Debug border
      }}
    >
      <h2
        style={{
          fontSize: isMobile ? "1.2rem" : "1.5rem",
          fontWeight: "bold",
          textAlign: "center",
          marginBottom: "24px",
          color: "white",
        }}
      >
        {t("Game Insights")}
      </h2>

      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: isMobile ? "stretch" : "flex-end",
          gap: "12px",
          marginBottom: "24px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label style={{ marginBottom: "4px", color: "white" }}>
            {t("From")}:
          </label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            style={{ padding: "4px" }}
          />
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label style={{ marginBottom: "4px", color: "white" }}>
            {t("To")}:
          </label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            style={{ padding: "4px" }}
          />
        </div>

        {/* ✅ Button container matches the input style */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label style={{ visibility: "hidden", marginBottom: "4px" }}>.</label>
          <button
            style={{
              padding: "6px 12px",
              borderRadius: "4px",
              backgroundColor: "#1976d2",
              color: "white",
              border: "none",
              cursor: "pointer",
            }}
            onClick={() => {
              setLoading(true);
              requestForGameInfos(fromDate, toDate);
            }}
          >
            {t("Apply Filter")}
          </button>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "14px",
        }}
      >
        <WinLossDrawChart gameInfos={gameInfos} />
        <GameTypeChart gameInfos={gameInfos} />
        <GameTimeTypeChart gameInfos={gameInfos} />
        <CombinedResultChart gameInfos={gameInfos} groupBy="gameTeamType" />
        <CombinedResultChart gameInfos={gameInfos} groupBy="gameTimeTypeDetails" />
        <UserTypeChart gameInfos={gameInfos} />
        <GameResultByOpponentTypeChart gameInfos={gameInfos} />
        <GamesPerDayChart gameInfos={gameInfos} />
      </div>
    </div>
  );
};

export default ChartsPage;
